import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, User } from 'lucide-react';
import axios from 'axios';

import { API } from "../config";

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    try {
      const response = await axios.get(`${API}/blog/posts`);
      setPosts(response.data);
    } catch (error) {
      console.error('Error fetching posts:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  return (
    <div className="min-h-screen pt-28 pb-20 bg-[#F9F6F0] relative overflow-hidden">
      {/* Background drifting blobs */}
      <div className="bg-blob blob-gold top-[10%] left-[-5%] w-[400px] h-[400px] opacity-35" />
      <div className="bg-blob blob-saffron bottom-[15%] right-[-5%] w-[450px] h-[450px] opacity-40" />

      <div className="container mx-auto max-w-6xl px-6 md:px-12 relative z-10">
        
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-[10px] font-bold tracking-widest uppercase text-[#D97706] mb-2 block">
            Vedic Lore & Insights
          </span>
          <h1 className="text-3xl md:text-5xl font-bold font-vedic text-[#352520] mb-4">
            Vastu Insights & Articles
          </h1>
          <p className="text-sm md:text-base text-[#5D4E37] max-w-xl mx-auto font-light leading-relaxed">
            Learn about Vastu Shastra principles, modern apartment architectural layouts, and expert remediation tips.
          </p>
        </div>

        {/* Blog Posts Grid */}
        {loading ? (
          <div className="text-center py-20">
            <div className="w-12 h-12 border-4 border-[#826239] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
            <p className="text-sm text-[#826239] font-medium">Loading articles...</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((post) => (
              <Link
                key={post.id}
                to={`/blog/${post.slug}`}
                className="bg-white border border-[#EBE6DD]/60 rounded-3xl overflow-hidden shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col justify-between group"
              >
                <div>
                  {/* Photo cover */}
                  <div className="aspect-video bg-[#FAF6EE] overflow-hidden border-b border-[#EBE6DD]/30">
                    <img
                      src={post.image_url}
                      alt={post.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  
                  {/* Text details */}
                  <div className="p-6">
                    <h3 className="text-lg font-bold font-vedic text-[#352520] mb-3 line-clamp-2 group-hover:text-[#D97706] transition-colors text-left">
                      {post.title}
                    </h3>
                    <p className="text-xs text-[#5D4E37] leading-relaxed font-light mb-4 line-clamp-3 text-left">
                      {post.excerpt}
                    </p>
                  </div>
                </div>

                {/* Footer metadata */}
                <div className="p-6 pt-0 mt-auto flex items-center gap-4 text-[10px] font-semibold text-[#826239]/80 border-t border-[#EBE6DD]/30 pt-4">
                  <div className="flex items-center gap-1">
                    <User className="w-3.5 h-3.5 text-[#D97706]" />
                    <span>{post.author}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Calendar className="w-3.5 h-3.5 text-[#D97706]" />
                    <span>{formatDate(post.published_at)}</span>
                  </div>
                </div>

              </Link>
            ))}
          </div>
        )}

        {!loading && posts.length === 0 && (
          <div className="text-center py-20 bg-white/40 rounded-3xl border border-[#EBE6DD]/60 p-8">
            <p className="text-[#826239] text-base font-light">No articles or insights published yet.</p>
          </div>
        )}

      </div>
    </div>
  );
};

export default Blog;
